module.exports = __webpack_public_path__ + "img/1993_no.481d3035.svg";